module.exports = __webpack_public_path__ + "media/images/royalslider/e-e964cd6f3b5b5a2d5f9358043afaaf43.jpg";